import Vue from 'vue';
import '@/styles/custom.scss'
import i18n from '@/plugins/i18n';
import App from './App.vue';
import router from './router';
import store from './store';
import vSelect from 'vue-select';

import BootstrapVue from 'bootstrap-vue'
import VueSimpleSVG from 'vue-simple-svg';
import 'vue-select/dist/vue-select.css';

import appLoader from '@/components/ui/appLoader'
import VueSvgInlinePlugin from 'vue-svg-inline-plugin';

import Hotjar from '@hotjar/browser';

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueSimpleSVG);
Vue.use(VueSvgInlinePlugin);
Vue.component('v-select', vSelect);
Vue.component('app-loader', appLoader)

// GLOBAL_ENV_CONFIG is set via kubernetes configMaps, see in /kubernetes deployment yaml files
// variable is not configured at build time, that's why eslint needs to be disabled here temporarily
/* eslint-disable */

let hotjarSiteId = null
const hotjarVersion = 6;
if(typeof GLOBAL_ENV_CONFIG === "undefined") {
  console.warn("GLOBAL_ENV_CONFIG not defined.")
} else {
  hotjarSiteId = GLOBAL_ENV_CONFIG && GLOBAL_ENV_CONFIG.HOTJAR_ID || null;
}
/* eslint-enable */  
Hotjar.init(hotjarSiteId, hotjarVersion);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');